import { bannerHeaderModuleDescriptionLenses } from 'root/src/client/logic/header/lenses'
import moduleDescriptions from 'root/src/shared/descriptions/modules'

const { viewBannerNewStyle } = bannerHeaderModuleDescriptionLenses

export default (state, { moduleId }) => viewBannerNewStyle(
	moduleId, moduleDescriptions,
)
